import {useState, useEffect} from "react";
import {Table, Modal} from 'antd';
import {Link, useSearchParams} from "react-router-dom";

import PageHeading from "../../shared/containers/PageHeading";
import LiveSearch from "../../modules/LiveSearch";
import PageFilters from "../../modules/PageFilters";
import ClientCard from "../../modules/CLientCard";

import {columns} from "./table";
import {searchFunction, getResultData, createAddressOptions} from "./stats";

import useAll from "../../shared/hooks/useAll";

import {getAllData} from "../../shared/services/missions";
import TotalCount from "../../shared/components/TotalCount/TotalCount";

const MissionsPage = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);

    const {
        statsVisible,
        search,
        setSearch,
        filteredInfo,
        sortedInfo,
        data,
        currentData,
        loading,
        pagination,
        handleChange,
        resetFilters,
        resetSorters,
        handleSearch,
        toogleStatsVisible,
    } = useAll({fetchData: getAllData, searchFunction});

    const columnsConfig = [...columns];


    columnsConfig[2].filteredValue = filteredInfo.status || null;
    columnsConfig[4].filteredValue = filteredInfo.category || null;

    columnsConfig[0].sortOrder = sortedInfo.columnKey === 'clients' ? sortedInfo.order : null;
    columnsConfig[1].sortOrder = sortedInfo.columnKey === 'delegates' ? sortedInfo.order : null;
    columnsConfig[2].sortOrder = sortedInfo.columnKey === 'status' ? sortedInfo.order : null;
    columnsConfig[4].sortOrder = sortedInfo.columnKey === 'category' ? sortedInfo.order : null;
    columnsConfig[5].sortOrder = sortedInfo.columnKey === 'amount' ? sortedInfo.order : null;

    columnsConfig[6].render = (_, record) => <Link to={`/missions/${record.id}`}>Manage</Link>;

    const searchData = getResultData(data, search, countries, cities);
    const searchCurrentData = getResultData(currentData, search, countries, cities);

    const {hits} = searchData;
    console.log(hits)
    return (
        <>
            <PageHeading title="Missions" subtitle="Everything about Missions">
                <LiveSearch value={search} placeholder="Client, Delegate" toogleStatsVisible={toogleStatsVisible}  onChange={handleSearch} statsVisible={statsVisible} />
            </PageHeading>
            <PageFilters   selectCountry={setCountries} selectCity={setCities} countries={createAddressOptions(searchCurrentData.countries)} cities={createAddressOptions(searchCurrentData.cities)} />
            <Table columns={columnsConfig} dataSource={hits} loading={loading} pagination={pagination}
                   onChange={handleChange}/>
            <TotalCount total={searchCurrentData?.hits?.length} />
            <Modal visible={modalOpen} onCancel={() => setModalOpen(false)} footer={null}>
                <ClientCard {...modalContent} />
            </Modal>
        </>
    )
}

export default MissionsPage;
